import { render } from "./notas-turmas.vue?vue&type=template&id=4782f856&scoped=true"
import script from "./notas-turmas.vue?vue&type=script&lang=js"
export * from "./notas-turmas.vue?vue&type=script&lang=js"

import "./notas-turmas.vue?vue&type=style&index=0&id=4782f856&lang=css"
import "./notas-turmas.vue?vue&type=style&index=1&id=4782f856&scoped=true&lang=css"
import "./notas-turmas.vue?vue&type=style&index=2&id=4782f856&scoped=true&lang=css"
import "./notas-turmas.vue?vue&type=style&index=3&id=4782f856&lang=scss&scoped=true"
import "./notas-turmas.vue?vue&type=style&index=4&id=4782f856&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4782f856"]])

export default __exports__